/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import address from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { systemITLocationOptions, handlingProtectedInformationDisciplinaryOptions } from 'constants/enums/informationTechnologyOptions';
import { REQUIRED } from 'constants/errors';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { isSafeUnitedStates } from 'helpers/locations';
import { LegalTechnologyNonComplianceItemModel } from '../types';


export const legalTechnologyNonComplianceItemValidator: ValidateJSModel<LegalTechnologyNonComplianceItemModel> = {

  Date: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      const { applicantBirthdate } = options;
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }
    return {};
  },
  Incident: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.NonComplianceIncidentLocation?.values?.includes('Other')) {
        return { presence: true, hasValue: true };
      }
      return {};
    }
    return { presence: true, hasValue: true };
  },

  Location: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        location: {
          requireIsMilitaryDiplomaticAddress: true,
          requireMilitaryDiplomaticInstallationName: true,
          requireStreet: isSafeUnitedStates(value),
          requireApoFpoDpoPostcode: !isSafeUnitedStates(value),
          validator: pvqLocationModelValidator,
        },
        presence: true,
      };
    }
    return { presence: true, location: { validator: address } };
  },
  // PVQ Only fields below
  NonComplianceIncidentLocation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        array: {
          length: {
            message: REQUIRED,
            minimum: 1,
          },
          validator: {
            inclusion: systemITLocationOptions,
            presence: true,
          }
        },
        presence: true,
      };
    }
    return {};
  },

  NonComplianceReason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  NonComplianceDisciplinaryAction: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        array: {
          length: {
            message: REQUIRED,
            minimum: 1,
          },
          validator: {
            inclusion: handlingProtectedInformationDisciplinaryOptions,
            presence: true,
          }
        },
        presence: true,
      };
    }
    return {};
  },

  DisciplinaryActionExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  DisciplinaryActionOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.NonComplianceDisciplinaryAction?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};
